export const ACTIVATION_DATE_KEY = 'confluence.ondemand.activationDate';
export const CONFLUENCE_MIGRATION_STATUS_KEY = 'confluence_migration_status';
export const CONFLUENCE_FIRST_MIGRATION_SIGNAL_DATE_KEY = 'confluence_first_migration_signal_date';
export const ENTITLEMENT_TYPE_KEY = 'confluence_entitlement_type';
export const MONTHS_UNTIL_MIGRATIONS_EXPIRY = 3;
export const MIGRATIONS_ENTITLEMENT_TYPE = 'EXTENDED_TRIAL';
export const ADDED_MIGRATED_USER_TAG = 'addedMigratedUserTag';
